export const firebaseConfig = {
  apiKey: "AIzaSyAv3Fg-BNGoJR3BC3_LtLeMTmiS1Fbeiqk",
  authDomain: "barcelona-cab-bec39.firebaseapp.com",
  projectId: "barcelona-cab-bec39",
  storageBucket: "barcelona-cab-bec39.firebasestorage.app",
  messagingSenderId: "279328978752",
  appId: "1:279328978752:web:38ac1ada9e18af12272ca5"
};


